export enum ChatWidgetStatus {
  LOADING = 'LOADING',
  READY = 'READY',
  STARTED = 'STARTED',
  CONTINUED = 'CONTINUED',
  ENDED = 'ENDED',
  ERROR = 'ERROR',
}

export enum DeviceType {
  MOBILE = 'MOBILE',
  TABLET = 'TABLET',
  DESKTOP = 'DESKTOP',
}

export interface FloatingButtonsPosition {
  bottom?: string;
  left?: string;
  right?: string;
}

export interface IFloatingButtonsPosition {
  closed: FloatingButtonsPosition;
  open: FloatingButtonsPosition;
}

export interface IChatWidgetState {
  status: ChatWidgetStatus;
  isWindowOpen: boolean;
  error: string | null;
  position: 'left' | 'right';
  floatingButtonsPosition: IFloatingButtonsPosition;
  isLegalAccepted: boolean;
  deviceType: DeviceType;
  isAgentsAvailable: boolean; // Track if agents are available (business hours)
  areFloatingButtonsHidden: boolean;
}
